/// <reference path="../_all.ts" />

module editor {
  'use strict';

  export interface IStatusTopicFilter extends ng.IFilterService {
    (name: 'statusTopic'): (sts: number) => number;
  }

  StatusTopic.$inject = [];
  export function StatusTopic() {
    return function (topics, sts) {
      var array = [];
      if (sts === 0) return topics;
      angular.forEach(topics, function (topic) {
        if (topic.ContentMeta.Status == sts) {
          array.push(topic);
        }
      });
      return array;
    };
  }
}